import { sagaCreator } from '@adrias-online/steiner';

import helper from 'helpers/steinerHelper';
import { actions, actionTypes } from '../actions/mailArchive';
import { selectors, DEFAULT_STATE } from '../reducers/mailArchive';
import api from '../apis/mailArchive';

const sagas = helper.createSagas(
    'mailArchive',
    actionTypes,
    actions,
    api,
    selectors,
    DEFAULT_STATE,
    {
        numberFilters: ['hotelId']
    }
);

const defaultSagas = sagaCreator.bootSagas(sagas, actionTypes);

export default [...defaultSagas];
